const map = {
	"./images/creasit-marker.png": 964,
	"./images/custom-marker.png": 816,
	"./images/icon-address.svg": 929,
	"./images/icon-location.svg": 586,
	"./images/icon-target.svg": 568,
	"./images/layers-2x.png": 897,
	"./images/layers.png": 640,
	"./images/marker-icon-2x.png": 601,
	"./images/marker-icon.png": 416,
	"./images/marker-shadow.png": 559,
	"./images/marker.svg": 115,
	"./images/osm.png": 23,
	"./images/satellite.png": 703,
	"./images/spritesheet.svg": 71
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 884;